import { isTouchDevice } from './device';

let enabled = true;

export function setHapticsEnabled(value: boolean): void {
  enabled = value;
}

export function toggleHaptics(): boolean {
  enabled = !enabled;
  return enabled;
}

export function hapticsEnabled(): boolean {
  return enabled;
}

function vibrate(pattern: number | number[]): void {
  if (!enabled || !isTouchDevice()) {
    return;
  }
  try {
    const nav = navigator as Navigator & { vibrate?: (value: number | number[]) => boolean };
    if (typeof nav.vibrate === 'function') {
      nav.vibrate(pattern);
    }
  } catch {
    return;
  }
}

export const haptics = {
  hit: (): void => vibrate(14),
  double: (): void => vibrate([16, 34, 24]),
  miss: (): void => vibrate(55),
  heart: (): void => vibrate([12, 26, 12, 26, 30]),
  fire: (): void => vibrate([22, 28, 22, 28, 44]),
  boost: (): void => vibrate(10),
  gameOver: (): void => vibrate([70, 60, 140]),
};
